import { useTranslation } from "react-i18next";

const PageForbidden = () => {
  const { t } = useTranslation();
  return <div>{t('not-allowed')}</div>;
};

export default PageForbidden;
